/**
 * Tracks whether the user is navigating by Tab or by pointer and writes it to
 * `<html data-spaces-modality>`. CSS in main.css only draws focus rings in
 * keyboard modality.
 *
 * Browsers flip `:focus-visible` on for *any* keypress, so a pointer user who
 * presses an arrow key to change gallery photos or Escape to close a modal
 * gets a ring on whatever holds focus. Only Tab (and roving arrow navigation
 * via `markKeyboardModality`) counts as keyboard navigation here.
 */
export type FocusModality = 'keyboard' | 'pointer'

function setModality (modality: FocusModality): void {
	document.documentElement.dataset.spacesModality = modality
}

export function markKeyboardModality (): void {
	setModality('keyboard')
}

export function getFocusModality (): FocusModality | undefined {
	return document.documentElement.dataset.spacesModality as FocusModality | undefined
}

export function trackFocusModality (): void {
	// Capture phase so the value is set before any handler moves focus.
	document.addEventListener('keydown', e => {
		if (e.key === 'Tab') setModality('keyboard')
	}, true)
	document.addEventListener('pointerdown', () => { setModality('pointer') }, true)
}
